import React from 'react';
import { useTheme } from '@mui/material';

export const Pointer = (props: React.SVGProps<SVGSVGElement>) => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryColor },
    } = theme.colors.other.icon;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={42} height={42} fill="none" {...props}>
            <path
                fill={primaryColor}
                d="M13.97 6.355c0-.974.784-1.758 1.758-1.758s1.758.784 1.758 1.758v9.68a1.171 1.171 0 0 0 1.955.872c.417-.374.96-.593 1.56-.593a2.34 2.34 0 0 1 2.336 2.16 1.171 1.171 0 0 0 1.955.784 2.341 2.341 0 0 1 3.903 1.56 1.171 1.171 0 0 0 1.955.784 2.343 2.343 0 0 1 3.91 1.741v8.202a5.857 5.857 0 0 1-5.858 5.858h-9.541a8.796 8.796 0 0 1-6.818-3.244l-5.506-6.781a1.757 1.757 0 0 1 .256-2.475 1.757 1.757 0 0 1 2.475.256l1.83 2.248a1.17 1.17 0 0 0 2.08-.74l-.007-20.312Zm1.758-4.101a4.103 4.103 0 0 0-4.1 4.1v17.048a4.097 4.097 0 0 0-5.514-.315 4.104 4.104 0 0 0-.6 5.77l5.506 6.774a11.145 11.145 0 0 0 8.64 4.115h9.542a8.197 8.197 0 0 0 8.201-8.201v-8.202a4.69 4.69 0 0 0-6.326-4.393 4.694 4.694 0 0 0-4.218-2.636c-.579 0-1.128.102-1.64.292a4.694 4.694 0 0 0-5.39-2.49v-7.76a4.103 4.103 0 0 0-4.1-4.101Zm5.273 23.432c0-.644-.527-1.171-1.172-1.171-.644 0-1.172.527-1.172 1.171v7.03c0 .645.528 1.172 1.172 1.172.645 0 1.172-.527 1.172-1.172v-7.03Zm4.686 0c0-.644-.527-1.171-1.171-1.171-.645 0-1.172.527-1.172 1.171v7.03c0 .645.527 1.172 1.172 1.172.644 0 1.171-.527 1.171-1.172v-7.03Zm4.687 0c0-.644-.527-1.171-1.172-1.171-.644 0-1.172.527-1.172 1.171v7.03c0 .645.528 1.172 1.172 1.172.644 0 1.172-.527 1.172-1.172v-7.03Z"
            />
        </svg>
    );
};

export default Pointer;
